var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":"","color":"footer"}},[_c('v-col',{staticClass:"text-center"},[_vm._v(" Copyright© eWeLL Corporation. All right reserved. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }